// Immutably removes all instances of a value from an array. Returns a new array.
export default function removeFromArray<T>(array: T[], value: T): T[] {
  return array.filter(other => other !== value);
}
